import Site from 'es/app/business-logic/domain-models/Site';
import { FACILITIES } from './graphql/root.facilities';
import {
    IUniversalSearchCriteria,
    MAX_RESULTS_PER_PROVIDER,
} from 'es/app/business-logic/services/universal-search/UniversalSearch';
import ApolloProvider from 'es/core/net/ApolloProvider';
import Guid, { toNakedGuid } from 'es/core/types/Guid';
import { UniversalFacilitySearchQuery, UniversalFacilitySearchQueryVariables } from 'es/app/__generated__/global';

export interface IFacilityMatch {
    id: Guid;
    name: string;
    companyName: string;
    site: Site;
}

interface ICompanyOrFacility {
    id: Guid;
    name: string;
    alias: string;
}

const NO_MATCH = () => false;

export async function universalFacilitySearch(criteria: IUniversalSearchCriteria) {
    const { data } = await ApolloProvider.root.query<
        UniversalFacilitySearchQuery,
        UniversalFacilitySearchQueryVariables
    >({
        query: FACILITIES,
    });

    const criteriaId = criteria.id ? toNakedGuid(criteria.id) : null;
    const criteriaTextRegex = (criteria.text && new RegExp(`${criteria.text}`, 'i')) || null;

    const isIdMatch = criteriaId ? (id: Guid) => criteriaId === toNakedGuid(id) : NO_MATCH;
    const isTextMatch = criteriaTextRegex ? (name: string) => criteriaTextRegex.test(name) : NO_MATCH;
    const isMatch = ({ id, name, alias }: ICompanyOrFacility) => {
        return isIdMatch(id) || isTextMatch(name) || isTextMatch(alias);
    };

    const results: IFacilityMatch[] = [];

    data?.system.companies.forEach(company => {
        const isCompanyMatch = isMatch(company);

        company.facilities?.forEach(facility => {
            if (isCompanyMatch || isMatch(facility)) {
                results.push({
                    id: facility.id,
                    name: facility.name,
                    companyName: company.name,
                    site: Site.get(company.alias, facility.alias),
                });
            }
        });
    });

    return results.slice(0, MAX_RESULTS_PER_PROVIDER);
}
